'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPaidHub = exports.provisionPartnerParcels = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// For upgrading Directory users to HubSpot Partner Agencies
var provisionPartnerParcels = exports.provisionPartnerParcels = function provisionPartnerParcels(portalId, countryCode) {
  return _apiClient2.default.post('/partnerdb/v1/provisioning/touchless?portalId=' + portalId, {
    data: {
      countryCode: countryCode,
      partnerType: 'SALES_SOLUTION'
    }
  });
};

var isPaidHub = exports.isPaidHub = function isPaidHub() {
  return _apiClient2.default.get('/iris-read/v1/app?hubField=paidHub').then(function (payload) {
    return payload.hub.paidHub;
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/parcelUtils.js
// module id = 727
// module chunks = 3 4